import {Directive, ElementRef} from "@angular/core";

@Directive({
    selector: 'ion-content'
})
export class IonContentElementQuery {

    constructor(public elementRef: ElementRef) {}

}



// WEBPACK FOOTER //
// ./src/vas/directives/ion-content-selector.directive.ts